<script setup lang="ts" name="BaseModalStatus">
import Icon from '~/components/Icon.vue';

import type {
  IconType,
  ModalPositionType,
  ModalTextAlignType,
  ModalTextColorType,
  ModalType,
} from '~/types';

const {
  title,
  message,
  icon = 'ic:baseline-delete',
  modalType = 'danger',
  position = 'center',
  textAlign = 'center',
  textColor = 'text-charcoal-6',
} = defineProps<{
  title: string;
  message?: string;
  icon?: IconType;
  modalType?: ModalType;
  position?: ModalPositionType;
  textAlign?: ModalTextAlignType;
  textColor?: ModalTextColorType;
}>();
</script>

<template>
  <div
    v-focus-trap
    tabindex="-1"
    date-test="dialog"
    class="relative z-50 w-full max-w-kpi-form flex-col rounded-md border-t-5 bg-white shadow-md"
    :class="{
      'border-red-6': modalType === 'danger',
      'border-navy-blue-6': modalType === 'info',
      'border-ocean-6': modalType === 'neutral',
      'flex-center': position === 'center',
    }"
  >
    <div
      class="absolute left-0 right-0 top-0 mx-auto -mt-[28px] flex h-09 w-09 items-center justify-center rounded-full border-4 border-solid border-white"
      :class="{
        'bg-red-6': modalType === 'danger',
        'bg-navy-blue-6': modalType === 'info',
        'bg-ocean-6': modalType === 'neutral',
      }"
    >
      <Icon :icon="icon" class="text-white" />
    </div>
    <div class="mx-8 mb-6 mt-09 max-w-2xl text-secondary-9">
      <h2 v-html="title" class="text-center text-subtitle-1 font-bold"></h2>
      <p
        v-if="message"
        v-html="message"
        class="mt-4 text-body-1 text-charcoal-6"
        :class="[
          {
            'text-center': textAlign === 'center',
          },
          textColor,
        ]"
      ></p>
      <div v-else class="h-1 w-96" />
      <slot />
    </div>
    <slot name="actions" />
  </div>
</template>
